import { Box, Skeleton, Stack } from '@mui/material';
import { Section } from '../../../common/section';

export const MarketplaceLoader = () => {
	return (
		<Section
			classList="!p-0"
			isShadow={false}
			children={
				<Box>
					{/* Image */}
					<Skeleton
						height={275}
						variant="rectangular"
						sx={{ width: '100%' }}
					/>

					<Stack gap={1} className="p-4">
						{/* Title — matches h-[62px] 2-line clamp */}
						<Box sx={{ height: '62px', overflow: 'hidden' }}>
							<Skeleton variant="text" sx={{ fontSize: '20px', width: '80%' }} />
							<Skeleton variant="text" sx={{ fontSize: '20px', width: '55%' }} />
						</Box>

						{/* Progress bar */}
						<Box className="mb-1">
							<Skeleton variant="rounded" sx={{ height: '28px', width: '100%', borderRadius: '10px' }} />
						</Box>

						{/* Requested amount */}
						<Box className="mt-2">
							<Skeleton variant="text" sx={{ fontSize: '14px', width: '160px' }} />
						</Box>

						{/* Data rows: ROI, IRR, Tenure, Repayments */}
						{[1, 2, 3, 4].map((row) => (
							<Box
								key={row}
								className="flex justify-between items-center py-3 border-b border-investor-deep">
								<Skeleton variant="text" sx={{ fontSize: '12px', width: '80px' }} />
								<Skeleton variant="text" sx={{ fontSize: '14px', width: '60px' }} />
							</Box>
						))}

						{/* Rating row — value is a circle badge */}
						<Box className="flex justify-between items-center py-3">
							<Skeleton variant="text" sx={{ fontSize: '12px', width: '60px' }} />
							<Skeleton variant="circular" width={28} height={28} />
						</Box>

						{/* Read More button — right-aligned, rounded-full */}
						<Box className="flex justify-end mt-4">
							<Skeleton
								variant="rounded"
								sx={{ width: '160px', height: '40px', borderRadius: '9999px' }}
							/>
						</Box>
					</Stack>
				</Box>
			}
		/>
	);
};
